
        <ng-container *ngIf="dialog.state$ | async as state">
            <div class="fixed inset-0 z-50 flex items-end justify-center bg-black/60 p-4 sm:items-center" (click)="close()">
                <div
                    class="w-full max-w-md rounded-3xl border border-[color:var(--border)] bg-[color:var(--card)] p-6 shadow-2xl"
                    (click)="$event.stopPropagation()"
                    role="dialog"
                    aria-modal="true"
                >
                    <div class="flex items-start justify-between gap-4">
                        <div class="min-w-0">
                            <p class="text-lg font-semibold text-[color:var(--foreground)]">Session expired</p>
                            <p class="mt-1 whitespace-pre-line text-sm text-[color:var(--muted-foreground)]">
                                {{ state.message || 'Please sign in again to continue without leaving this page.' }}
                            </p>
                        </div>
                        <button
                            type="button"
                            class="rounded-full p-2 text-[color:var(--muted-foreground)] transition hover:bg-[color:var(--hover)]"
                            (click)="close($event)"
                            aria-label="Close"
                        >
                            <lucide-icon name="x" class="h-4 w-4"></lucide-icon>
                        </button>
                    </div>

                    <div class="mt-5 space-y-4">
                        <div class="flex items-center gap-2 rounded-full border border-[color:var(--border)] bg-[color:var(--secondary)] p-1">
                            <button
                                type="button"
                                class="h-9 flex-1 rounded-full text-sm font-semibold transition"
                                [ngClass]="method() === 'password' ? 'bg-[color:var(--card)] shadow text-[color:var(--foreground)]' : 'text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)]'"
                                (click)="setMethod('password')"
                            >
                                Password
                            </button>
                            <button
                                type="button"
                                class="h-9 flex-1 rounded-full text-sm font-semibold transition"
                                [ngClass]="method() === 'otp' ? 'bg-[color:var(--card)] shadow text-[color:var(--foreground)]' : 'text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)]'"
                                (click)="setMethod('otp')"
                            >
                                OTP
                            </button>
                        </div>

                        <div class="flex items-center gap-2 rounded-full border border-[color:var(--border)] bg-[color:var(--secondary)] p-1">
                            <button
                                type="button"
                                class="h-9 flex-1 rounded-full text-sm font-semibold transition"
                                [ngClass]="identifier() === 'phone' ? 'bg-[color:var(--card)] shadow text-[color:var(--foreground)]' : 'text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)]'"
                                (click)="setIdentifier('phone')"
                            >
                                Phone
                            </button>
                            <button
                                type="button"
                                class="h-9 flex-1 rounded-full text-sm font-semibold transition"
                                [ngClass]="identifier() === 'email' ? 'bg-[color:var(--card)] shadow text-[color:var(--foreground)]' : 'text-[color:var(--muted-foreground)] hover:text-[color:var(--foreground)]'"
                                (click)="setIdentifier('email')"
                            >
                                Email
                            </button>
                        </div>

                        <form *ngIf="method() === 'password'; else otpTpl" [formGroup]="passwordForm" (ngSubmit)="onPasswordSubmit()" class="space-y-3">
                            <ng-container *ngIf="identifier() === 'phone'; else emailPasswordTpl">
                                <app-phone-input formControlName="mobile"></app-phone-input>
                            </ng-container>
                            <ng-template #emailPasswordTpl>
                                <label class="space-y-1 block">
                                    <span class="text-sm font-semibold text-[color:var(--muted-foreground)]">Email</span>
                                    <input
                                        formControlName="email"
                                        type="email"
                                        class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-4 py-3 text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:border-[color:var(--ring)] focus:outline-none"
                                        placeholder="name@example.com"
                                    />
                                </label>
                            </ng-template>

                            <label class="space-y-1 block">
                                <span class="text-sm font-semibold text-[color:var(--muted-foreground)]">Password</span>
                                <input
                                    formControlName="password"
                                    type="password"
                                    class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-4 py-3 text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:border-[color:var(--ring)] focus:outline-none"
                                    placeholder="••••••••"
                                />
                            </label>

                            <button
                                type="submit"
                                [disabled]="loading()"
                                class="w-full rounded-xl bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-[color:var(--primary-foreground)] h-11 font-semibold transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
                            >
                                <lucide-icon *ngIf="loading()" name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                                <span>{{ loading() ? 'Signing in...' : 'Sign in' }}</span>
                            </button>
                        </form>

                        <ng-template #otpTpl>
                            <form [formGroup]="otpForm" (ngSubmit)="onOtpSubmit()" class="space-y-3">
                                <ng-container *ngIf="identifier() === 'phone'; else emailOtpTpl">
                                    <app-phone-input formControlName="mobile"></app-phone-input>
                                </ng-container>
                                <ng-template #emailOtpTpl>
                                    <label class="space-y-1 block">
                                        <span class="text-sm font-semibold text-[color:var(--muted-foreground)]">Email</span>
                                        <input
                                            formControlName="email"
                                            type="email"
                                            class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-4 py-3 text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:border-[color:var(--ring)] focus:outline-none"
                                            placeholder="name@example.com"
                                        />
                                    </label>
                                </ng-template>

                                <label *ngIf="otpStep() === 'code'" class="space-y-1 block">
                                    <span class="text-sm font-semibold text-[color:var(--muted-foreground)]">Code</span>
                                    <input
                                        formControlName="code"
                                        type="text"
                                        inputmode="numeric"
                                        maxlength="6"
                                        class="w-full rounded-xl border border-[color:var(--input)] bg-[color:var(--card)] px-4 py-3 text-[color:var(--foreground)] placeholder:text-[color:var(--text-subtle)] focus:border-[color:var(--ring)] focus:outline-none"
                                        placeholder="123456"
                                    />
                                </label>

                                <button
                                    type="submit"
                                    [disabled]="loading()"
                                    class="w-full rounded-xl bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-[color:var(--primary-foreground)] h-11 font-semibold transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
                                >
                                    <lucide-icon *ngIf="loading()" name="loader-2" class="h-4 w-4 animate-spin"></lucide-icon>
                                    <span>{{ otpButtonLabel }}</span>
                                </button>

                                <button
                                    *ngIf="otpStep() === 'code'"
                                    type="button"
                                    (click)="resendOtp()"
                                    [disabled]="loading()"
                                    class="w-full rounded-xl border border-[color:var(--border)] bg-[color:var(--card)] h-11 font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)] disabled:opacity-60"
                                >
                                    Resend code
                                </button>
                            </form>
                        </ng-template>

                        <div *ngIf="message()" class="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800">
                            {{ message() }}
                        </div>
                        <div *ngIf="error()" class="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                            {{ error() }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    
